// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateColombianCity(cityValue: string): ?UserInputValidationError {
  return cityValue ? VALID : { id: 'empty' };
}
